import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const Custom_URL = `${API_URL}/custom`;
const Product_URL = `${API_URL}/subscription`;

const listBrand = () => {
  return axios.get(`${Custom_URL}/list-brand`).then((response) => {
    return response;
  });
};

const listPlanFeature = () => {
  return axios.get(`${Custom_URL}/list-plan-features`).then((response) => {
    return response;
  });
};
const listSpeacification = () => {
  return axios.get(`${Custom_URL}/list-speacification`).then((response) => {
    return response;
  });
};
const listVariant = () => {
  return axios.get(`${Custom_URL}/list-variant`).then((response) => {
    return response;
  });
};
const listCategory = () => {
  return axios.get(`${Custom_URL}/list-category`).then((response) => {
    return response;
  });
};
const getProduct = () => {
  return axios.get(`${Custom_URL}/list-product`).then((response) => {
    return response;
  });
};
const listSubscriptionPlans = () => {
  return axios.get(`${Product_URL}/list-subscription-products`).then((response) => {
    return response;
  });
};

const createProduct = (formData: FormData) => {
  return axios.post(`${Product_URL}/add`,  formData).then((response) => {
    return response;
  });
};

const updateProduct = (formData: FormData, id: any) => {
  return axios.put(`${Product_URL}/edit/${id}`,  formData).then((response) => {
    return response;
  });
};

const viewProduct = (id: any) => {
  return axios.get(`${Product_URL}/view/${id}`).then((response) => {
    return response;
  });
};
const getUserListPlans = (id: any, params?: { filter?: string; page?: number; limit?: number }) => {
  return axios.get(`${Product_URL}/user-subscription/${id}`, { params }).then((response) => {
    return response;
  });
};


const deleteProduct = (id: any) => {
  return axios.put(`${Product_URL}/delete/${id}`).then((response) => {
    return response;
  });
};

const createPlanSubscription = async (data: FormData) => {
  try {
    const response = await axios.post(`${Product_URL}/add-subscription-products`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response;
  } catch (error) {
    console.error("Error creating plan subscription:", error);
    return { status: false, message: "Failed to create plan subscription" };
  }
};
const editPlanSubscription = async (id:any,data: FormData) => {
  try {
    const response = await axios.put(`${Product_URL}/edit-subscription-products/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response;
  } catch (error) {
    console.error("Error creating plan subscription:", error);
    return { status: false, message: "Failed to create plan subscription" };
  }
};
const viewPlanSubscription = (id: any) => {
  return axios.get(`${Product_URL}/view-subscription-products/${id}`).then((response) => {
    return response;
  });
};
const deletePlanSubscription = (id: any) => {
  return axios.post(`${Product_URL}/delete-subscription-products/${id}`).then((response) => {
    return response;
  });
};
const updateSubscriptionPlanStatus = (id: any, data: any) => {
  return axios
    .patch(`${Product_URL}/update-plan-status/${id}`, data, {
      headers: { "Content-Type": "application/json" },
    })
    .catch((error) => {
      console.error("Error updating plan status:", error);
      return { status: false, message: "Failed to update plan status" };
    });
};

export {
  getProduct,
  getUserListPlans,
  createPlanSubscription,
  editPlanSubscription,
  viewPlanSubscription,
  deletePlanSubscription,
  listBrand,
  listPlanFeature,
  listSpeacification,
  listVariant,
  listCategory,
  listSubscriptionPlans,
  createProduct,
  updateProduct,
  viewProduct,
  deleteProduct,
  updateSubscriptionPlanStatus,
};
